export default __webpack_public_path__ + "static/media/login.8c21af51.svg";